export * from "./produtos-sem-venda.component";
